module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8RJC9"))).then(() => parcelRequire('f4eak'));